import { type ReactElement } from 'react'
import { TListItem } from 'app/components/terros'
import { TAuditInfoSection } from 'app/components/auditInfo'
import { type TeamData } from '@terros/common'
import { useTranslation } from '@front/model'

type Props = {
  team: TeamData
}
export const TeamAuditSection = ({ team }: Props): ReactElement => {
  const { t } = useTranslation()

  return (
    <TAuditInfoSection {...team}>
      <TListItem detailBold canCopy details={team.teamId} label={t('Team ID')} />
    </TAuditInfoSection>
  )
}
